
import React from "react";

const ActionModal = ({ id, title, children, onSubmit }) => (
  <div
    className="modal fade"
    id={id}
    tabIndex={-1}
    aria-labelledby={`${id}Label`}
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id={`${id}Label`}>{title}</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form onSubmit={onSubmit || ((e) => e.preventDefault())}>
          <div className="modal-body">{children}</div>
          {/* Buttons should be passed via children (e.g., <ModalFooter />) */}
        </form>
      </div>
    </div>
  </div>
);

export default ActionModal;
